import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators  } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../shared/admin/admin.service';
import { CustomerService } from '../shared/customer/customer.service';
import { ModeratorService } from '../shared/moderator/moderator.service';
import { ExpertService } from '../shared/techExpert/expert.service';
import { LoginService } from '../shared/user-login/login.service';

@Component({
    selector: 'app-land',
    templateUrl: './land.component.html',
    styleUrls: ['./land.component.css'],
    standalone: false
})
export class LandComponent implements OnInit {

  showSucessMessage: boolean;
  serverErrorMessages: string;
  loading: boolean = true
  role = new FormControl('', [Validators.required]);
  userForm = new FormGroup({
    userName: new FormControl('',
    [Validators.required]),
    password: new FormControl('',
    [Validators.required,
    Validators.minLength(8)]),
    fullName: new FormControl('',
    [Validators.required]),
    contactNumber: new FormControl('',
    [Validators.required,
    Validators.minLength(10),
    Validators.maxLength(10)]),
    email: new FormControl('',
    [Validators.required,
    Validators.email])
  })
  roles = ['Customer', 'Moderator', 'TechExpert']
  roleDict = {
    'Customer': '1',
    'Moderator': '2',
    'TechExpert': '3'
  }
  constructor(public customerService: CustomerService, public adminService: AdminService, public moderatorService: ModeratorService,
    public expertService: ExpertService, private loginService: LoginService, private router : Router, private activatedRoute: ActivatedRoute ) {}

 ngOnInit(): void {
  //console.log('Inside sign-up OnInit')
   if(this.loginService.isLoggedIn()){
    //console.log('Customer is logged in');
     window.alert('User is already logged in');
     this.loading = false;
     this.router.navigateByUrl('/home');
   }else{
   this.loading = false;
    }
  }

  onSubmit(){
   //console.log('land form value', this.role.value, this.userForm.value);
    switch(this.roleDict[this.role.value]){
      case '1':
        this.customerService.postCustomer({...this.userForm.value, role: this.role.value.toUpperCase()}).subscribe(
          res => {
           //console.log('success', res);
            this.showSucessMessage = true;
            setTimeout(() => this.showSucessMessage = false, 4000);
            this.router.navigateByUrl('/signin');
          },
          err => {
           //console.log('error inside',err)
            this.serverErrorMessages = 'Something went wrong.Please contact admin.';
          }
        );
        break

      case '2':
        this.moderatorService.postModerator({...this.userForm.value, role: this.role.value.toUpperCase()}).subscribe(
          res => {
           //console.log('success', res);
            this.showSucessMessage = true;
            setTimeout(() => this.showSucessMessage = false, 4000);
            this.router.navigateByUrl('/signin');
          },
          err => {
           //console.log('error inside',err)
            this.serverErrorMessages = 'Something went wrong.Please contact admin.';
          }
        );
        break;

      case '3':
        this.expertService.postExpert({...this.userForm.value, role: this.role.value.toUpperCase()}).subscribe(
          res => {
           //console.log('success', res);
            this.showSucessMessage = true;
            setTimeout(() => this.showSucessMessage = false, 4000);
            this.router.navigateByUrl('/signin');
          },
          err => {
           //console.log('error inside',err)
            this.serverErrorMessages = 'Something went wrong.Please contact admin.';
          }
        );
        break;

    }
  }

}
